export default __webpack_public_path__ + "static/bg-gradient-04e991cba6ea2e5cc7ad795ffe091bcf.jpg";